/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react'
import { useRecoilState } from 'recoil'
import styled from '@emotion/styled'
import { Chip, Tab } from '@mui/material'
import { Colors, Shapes, Typographies, useTypography } from 'src/components/theme'
import { PillTabs } from 'src/components/pill-tabs'
import { SubscriptionsGrid } from 'src/views/subscriptions/table/grid'
import { SUBSCRIPTION_OCCURRENCE_OPTIONS } from 'src/constants/subscriptions'
import { SubscriptionTableHeaderProps } from 'src/views/subscriptions/table/header'

import * as paymentsAtoms from 'src/atoms/payments'

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[4]}px;
  overflow: hidden;
`
const Header = styled.div`
  display: flex;
`
const PillTabsWrapper = styled.div`
  background-color: ${Colors.bgWhite};
  padding: ${Shapes.spacing[1]}px;
  border-radius: ${Shapes.spacing[2]}px;
  border: solid 1px ${Colors.borderInput};
`
const Label = styled.span`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
`
export const LabelExtra = styled(Chip)`
  height: auto;
  padding: ${Shapes.spacing[1] / 2}px ${Shapes.spacing[2]}px;
  margin-bottom: -1px;
  span {
    ${useTypography(Typographies.textmdm)}
    padding: 0;
  }
`

const TabLabel = (props: { option: (typeof SUBSCRIPTION_OCCURRENCE_OPTIONS)[number] }) => {
  return (
    <Label>
      {props.option.label}
      {props.option.extra && <LabelExtra color={'warning'} label={props.option.extra} />}
    </Label>
  )
}

export const SubscriptionsTable = (props: SubscriptionTableHeaderProps) => {
  const { onUpgrade, onDowngrade } = props
  const [occurrence, setOccurrence] = useRecoilState(paymentsAtoms.subscriptionInterval)

  const tab = useMemo(
    () => SUBSCRIPTION_OCCURRENCE_OPTIONS.findIndex((option) => option.id === occurrence),
    [occurrence]
  )

  const onTabChange = (_: React.SyntheticEvent, newValue: number) =>
    setOccurrence(SUBSCRIPTION_OCCURRENCE_OPTIONS[newValue].id)

  return (
    <Wrapper>
      <Header>
        <PillTabsWrapper>
          <PillTabs color={Colors.blueDark} value={tab} onChange={onTabChange}>
            {SUBSCRIPTION_OCCURRENCE_OPTIONS.map((option, index) => (
              <Tab key={option.id} value={index} label={<TabLabel option={option} />} />
            ))}
          </PillTabs>
        </PillTabsWrapper>
      </Header>
      <SubscriptionsGrid onUpgrade={onUpgrade} onDowngrade={onDowngrade} />
    </Wrapper>
  )
}
